import React from 'react';
import WeighingInterface from '@/components/WeighingInterface';

const QualityAnalysisPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <WeighingInterface 
        filterStatus="BRUT_ENREGISTRE"
        pageTitle="Pesées en Attente d'Analyse Qualité"
        pageDescription="Gérez les pesées en attente d'analyse qualité"
      />
    </div>
  );
};

export default QualityAnalysisPage;
